import React from "react"
import usePublicCounters from "../hooks/usePublicCounters.js"
import CounterTile from "./CounterTile.jsx"

const GROUPS = [
  {
    eyebrow: "Outcomes",
    tiles: [
      { name: "additional_conversions", label: "Conversions caused" },
      { name: "winners_declared", label: "Winners declared" },
      { name: "avg_lift_pct", label: "Average lift" },
      { name: "proposals_total", label: "Proposals shaped" },
    ],
  },
  {
    eyebrow: "Activity",
    tiles: [
      { name: "snippet_boots_total", label: "Snippet boots" },
      { name: "dom_mutations_applied", label: "DOM mutations applied" },
      { name: "ai_calls_total", label: "AI calls run" },
      { name: "cumulative_impressions", label: "Variant impressions" },
    ],
  },
  {
    eyebrow: "Coverage",
    tiles: [
      { name: "shops_active", label: "Shops active" },
      { name: "countries_served", label: "Countries served" },
      { name: "languages_served", label: "Languages served" },
      { name: "currencies_served", label: "Currencies served" },
    ],
  },
]

export default function CountersStrip() {
  const { byName, lastUpdated, error } = usePublicCounters()

  return (
    <section className="border-t border-[color:var(--color-rule)] bg-[color:var(--color-surface-card)]">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <div className="mb-16 flex items-end justify-between gap-12 flex-wrap">
          <div>
            <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-[color:var(--color-ai)] mb-4">
              § 02 · The fleet, live
            </p>
            <h2 className="font-sans text-[40px] tracking-[-0.035em] font-medium leading-[1.1] max-w-2xl">
              Across every shop running ShopShift right now.
            </h2>
            <p className="mt-4 font-sans text-[15px] text-[color:var(--color-ink-secondary)] max-w-xl leading-[1.55]">
              Real numbers, real shops. Refreshed every 60&nbsp;seconds. Watch them tick.
            </p>
          </div>

          <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.12em] uppercase text-[color:var(--color-ink-faint)]">
            <span
              className={`inline-block w-1.5 h-1.5 rounded-full ${
                error ? "bg-[color:var(--color-negative)]" : "bg-[color:var(--color-winner-dot)]"
              }`}
              style={{
                animation: error ? "none" : "pulse 2s ease-in-out infinite",
              }}
            />
            {error ? "Reconnecting" : lastUpdated ? "Streaming live" : "Connecting"}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-12 gap-y-16">
          {GROUPS.map((group) => (
            <div key={group.eyebrow} className="flex flex-col gap-10">
              <div className="border-t border-[color:var(--color-rule-strong)] pt-4">
                <p className="font-mono text-[11px] tracking-[0.18em] uppercase font-medium text-[color:var(--color-ink-primary)]">
                  {group.eyebrow}
                </p>
              </div>
              {group.tiles.map((tile) => (
                <CounterTile key={tile.name} label={tile.label} counter={byName.get(tile.name)} size="md" />
              ))}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
      `}</style>
    </section>
  )
}
